import * as service from './service'
export default {
  namespace: 'customerServiceProcessRecords',
  state: {
    demoData: {}
  },
  effects: {
    * pagingProcessingProgress ({ payload }, { call, put }) {
      const res = yield call(service.pagingProcessingProgress, payload)
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
